const R_GOL_FULFILLMENT_SITE_IDS = [
  '29',
  '30',
  '31',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38'
];

/**
 * Returns the fulfiller of the current site.
 * @returns {string}
 */
export default function getSiteFulfiller() {
  const { siteId } = window;
  if (R_GOL_FULFILLMENT_SITE_IDS.includes(siteId)) {
    return 'R-GOL';
  }
  return 'Unisport';
}
